import { setMetadata } from '@sheerid/jslib';

export const setQueryStringMetadata = (metadataFields: string[]) => {
    const urlParams = new URLSearchParams(window.location.search);

    for (const field of metadataFields) {
        const metadataFieldValue = urlParams.get(field);

        if (metadataFieldValue) {
            setMetadata({ [field]: metadataFieldValue });
        }
    }
};
